module.exports = __webpack_public_path__ + "static/fonts/AkkuratPro-Regular.4324062.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/AkkuratPro-Regular.woff2
// module id = Lsme
// module chunks = 1